import React from 'react';
import images from '../../Utils/images';
import colors from '../../Utils/colors';
import CheerioButton from '../../Components/CheerioButton';

const InstagramSetup = ({ onclickAction, skipSetupAction }) => {
  return (
    <>
      <div className="w-100 h-100 Column justify-content-center">
        <div className="Column" style={{ width: '60%' }}>
          {/* <h1
            style={{
              color: colors.primary04,
              fontSize: 40,
              width: '100%',
              marginBlock: 24,
            }}
          >
            {'omnybox'}
          </h1> */}
          <img
            src={images.OBLogoText}
            style={{
              height: 40,
              width: 'auto',
              objectFit: 'contain',
              marginBlockEnd: 24,
            }}
          />
          <h2
            style={{
              marginBlock: 16,
              width: '100%',
            }}
          >
            {'Connect your account'}
          </h2>
          <p
            style={{
              width: '100%',
              color: colors.greys04,
              marginBlock: 8,
            }}
          >
            {'To continue, You need to connect your Instagram Account with Omnybox for further setup.'}
          </p>
          <p
            style={{
              width: '100%',
              fontWeight: 500,
              marginBlock: 24,
              fontSize: 16,
            }}
          >
            {'Pre-requisites'}
            <br />
            <span style={{ fontWeight: 400, fontSize: 14 }}>
              1. An Instagram Business account.
              <br />
              2. Facebook page with admin access.
              <br />
              3. Messaging permissions enabled in Instagram. Watch video.
              <br />
              4. Associated Instagram business account with Facebook Business page.
            </span>
          </p>
          <CheerioButton
            btnText={'Continue with Facebook'}
            textStyle={{ marginBlock: '24px' }}
            onclick={() => {
              console.log('insta action');
              onclickAction();
            }}
          />
          <p style={{ color: colors.greys04, marginBlock: 12 }}>
            {'Need help? '}
            <span
              style={{ color: colors.linkblue, cursor: 'pointer' }}
              onClick={() => {
                window.open('https://developers.facebook.com/docs/messenger-platform/instagram/features/webhook', '_blank');
              }}
            >
              {'Read Article'}
            </span>
            {' or '}
            <span
              style={{ color: colors.linkblue, cursor: 'pointer' }}
              onClick={() => {
                window.open('https://drive.google.com/file/d/143AbuuyYos-DWccqUYTTrP99S0D4VN5Y/view', '_blank');
              }}
            >
              {'Watch Video'}
            </span>
          </p>
          <p
            style={{ color: colors.greys04, cursor: 'pointer' }}
            onClick={() => {
              skipSetupAction();
            }}
          >
            {'Skip to login'}
          </p>
        </div>
      </div>
    </>
  );
};

export default InstagramSetup;
